import { ReactNode } from 'react';
import MuiTypography, { TypographyProps as MuiTypographyProps } from '@mui/material/Typography';

interface TypographyProps extends Omit<MuiTypographyProps, 'children'> {
  children: ReactNode;
}

export function Typography({ children, variant, ...otherProps }: TypographyProps) {
  return (
    <MuiTypography variant={variant} {...otherProps}>
      {children}
    </MuiTypography>
  );
}
